import {Injectable} from '@angular/core';
import {z} from 'zod';

export const legislationSchema = z.object({
    active: z
        .boolean()
        .nullable()
        .transform(it => it ?? false),
    legislationId: z.string(),
});

export type Legislation = z.infer<typeof legislationSchema>;

@Injectable({
    providedIn: 'root',
})
export class LegislationsAdapter {
    toApiModel(items: Legislation[]): any {
        return items
            .filter(item => item.active)
            .map(item => ({
                legislationId: item.legislationId,
            }));
    }
}

export const legislationResponseSchema = z.object({
    legislationId: z.string(),
});

export type LegislationResponse = z.infer<typeof legislationResponseSchema>;
